export default __webpack_public_path__ + "static/media/diamond-frame.7c17f70b.png";